import { render, staticRenderFns } from "./FieldPage.vue?vue&type=template&id=b620a572&scoped=true"
import script from "./FieldPage.vue?vue&type=script&lang=js"
export * from "./FieldPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620a572",
  null
  
)

export default component.exports